import {
  LegalEntitySelectorFormFieldDocument,
  LegalEntitySelectorFormFieldQuery,
} from 'generated/resources/graphql'

import {
  createGraphqlDataSourceDefinition,
  useGraphqlDataSource,
} from 'modules/core/hooks/useGraphqlDataSource'

export type LegalEntityRecord = {
  id: string
  legalName: string
  country: string
}

const legalEntitySelectorSourceDefinition = createGraphqlDataSourceDefinition({
  document: LegalEntitySelectorFormFieldDocument,
  paginationType: 'infinite-scroll',
  perPage: 20,
  mapVariables: ({ search }) => ({
    search: search || undefined,
  }),
  mapData: (data: LegalEntitySelectorFormFieldQuery): LegalEntityRecord[] =>
    data.companies?.legalEntitiesConnection?.edges?.map((edge) => ({
      id: edge.node.id,
      legalName: edge.node.legalName,
      country: edge.node.country,
    })) ?? [],
  mapPagination: (data: LegalEntitySelectorFormFieldQuery) => ({
    total: data.companies?.legalEntitiesConnection?.totalCount ?? 0,
    cursor: data.companies?.legalEntitiesConnection?.pageInfo?.endCursor ?? undefined,
    hasNextPage: data.companies?.legalEntitiesConnection?.pageInfo?.hasNextPage ?? false,
  }),
})

export const useLegalEntitySelectorSource = () => {
  return useGraphqlDataSource(legalEntitySelectorSourceDefinition)
}
